import type { CandleWithFlag } from "features/chart";

function calcEMA(values: (number | null)[], period: number): (number | null)[] {
  const result: (number | null)[] = new Array(values.length).fill(null);
  const k = 2 / (period + 1);
  let prev: number | null = null;
  let seedSum = 0, seedCount = 0;
  for (let i = 0; i < values.length; i++) {
    const v = values[i];
    if (v === null) continue;
    if (prev === null) {
      seedSum += v;
      seedCount++;
      if (seedCount === period) { prev = seedSum / period; result[i] = prev; }
    } else {
      prev = v * k + prev * (1 - k);
      result[i] = prev;
    }
  }
  return result;
}

function calcSMA(values: (number | null)[], period: number): (number | null)[] {
  const result: (number | null)[] = new Array(values.length).fill(null);
  let sum = 0, count = 0;
  const window: number[] = [];
  for (let i = 0; i < values.length; i++) {
    const v = values[i];
    if (v === null) continue;
    window.push(v);
    sum += v;
    if (window.length > period) sum -= window.shift()!;
    if (window.length === period) result[i] = sum / period;
  }
  return result;
}

export function calcOsMA(
  data: CandleWithFlag[],
  fastEmaPeriod: number,
  slowEmaPeriod: number,
  signalSmaPeriod: number,
): (number | null)[] {
  const closes: (number | null)[] = data.map(c => ("close" in c ? c.close : null));
  const fastEMA = calcEMA(closes, fastEmaPeriod);
  const slowEMA = calcEMA(closes, slowEmaPeriod);

  const macdLine: (number | null)[] = fastEMA.map((f, i) => {
    const s = slowEMA[i];
    return f !== null && s !== null ? f - s : null;
  });

  const signal = calcSMA(macdLine, signalSmaPeriod);

  return macdLine.map((m, i) => {
    const s = signal[i];
    return m !== null && s !== null ? m - s : null;
  });
}
